const canRateProduct = (product) =>
  !!product?.rating && product?.is_available_for_user !== false;

export default canRateProduct;
